/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
var e = 33984;
var r;
!function (e) {
  e[e.Texture = 0] = "Texture", e[e.Buffer = 1] = "Buffer", e[e.VAO = 2] = "VAO", e[e.VertexShader = 3] = "VertexShader", e[e.FragmentShader = 4] = "FragmentShader", e[e.Program = 5] = "Program", e[e.Framebuffer = 6] = "Framebuffer", e[e.Renderbuffer = 7] = "Renderbuffer", e[e.COUNT = 8] = "COUNT";
}(r || (r = {}));
var f = 33306;
export { e as BASE_TEXTURE_UNIT, f as DepthStencilAttachment, r as ResourceType };